export function updateStep2Action(
  state: any,
  payload: {
    experienceLevel: any;
    experienceYearsMin: any;
    experienceYearsMax: any;
    salaryMin: any;
    salaryMax: any;
    languages: any;
    education: any;
    rolesAndResponsibilities: any;

    progressStep: any;
  }
) {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload,
    },
  };
}
